import { BlueBirdTheme, Typography } from "@kitbird/core";
import styled from "styled-components";
import { ReactNode } from "react";
import { ReactComponent as MoneyIcon } from "../../assets/icons/money.svg";
import { toRupiah } from "../../utils/common";

export interface SummaryI {
  type: "primary" | "success" | "warning",
  title?: string | ReactNode,
  amount?: string,
}

const { colors } = BlueBirdTheme;

const Wrapper = styled.div`
  border-radius: 8px;
  width: 100%;
  height: 69px;
  padding: 12px;

  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
`;

const IconWrapper = styled.div`
  height: 32px;
  width: 32px;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 50%;

`;

const Summary = ({ type, title, amount }: SummaryI) => (
  <Wrapper style={{ backgroundColor: colors[type][200] }}>
    <IconWrapper style={{ backgroundColor: colors[type][300] }}>
      <MoneyIcon />
    </IconWrapper>
    <div>
      <div>
        <Typography
          level={6}
          color={colors[type][400]}
        >
          {title}
        </Typography>
      </div>
      <div>
        <Typography
          level={5}
          color={colors[type][500]}
          fontWeight="medium"
        >
          {amount ? toRupiah(amount) : "-"}
        </Typography>
      </div>
    </div>
  </Wrapper>
);

export default Summary;
